import React from 'react';

export const Notes = () => {
  return <div>Notes</div>;
};
